import React from 'react';
import CarbonRetirementCard from './CarbonRetirementCard';
import {
  RetirementsListGrid
} from './CarbonRetirements.styles';

export default function CarbonRetirementsList({ results }) {
  // Os resultados já vêm filtrados da API, não precisamos filtrar novamente

  return (
    <section>
      <RetirementsListGrid>
        {results.map(r => (
          <CarbonRetirementCard key={r._id} r={r} />
        ))}
      </RetirementsListGrid>
    </section>
  );
}
